// Dismiss wrapper for summary widgets. No data dependencies; the dismiss
// handler is supplied by the page's useWidgetVisibility hook, which
// owns the persistence (localStorage today, `user_preferences` later).
//
// Postgres mapping: none directly. See useWidgetVisibility.js.
// Integration hook: none.
import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

// Wraps a summary card and renders a small dismiss "x" in the top-right that
// hides the widget via the page's widget-visibility hook. The button is only
// rendered when both `id` and `onDismiss` are supplied, so this composes
// safely with cards that don't yet opt in.
export default function DismissableCard({ id, onDismiss, children, sx }) {
    return (
        <Box sx={{ position: 'relative', height: '100%', width: '100%', minWidth: 0, ...sx }}>
            {id && onDismiss && (
                <IconButton
                    aria-label="Hide card"
                    size="small"
                    onClick={(e) => { e.stopPropagation(); onDismiss(id); }}
                    sx={{
                        position: 'absolute',
                        top: 6,
                        right: 6,
                        zIndex: 2,
                        padding: '2px',
                        color: 'text.disabled',
                        opacity: 0,
                        transition: 'opacity .15s, color .15s',
                        '&:hover': { color: 'text.secondary' },
                        '&:focus-visible': { opacity: 1, outline: '2px solid', outlineColor: 'secondary.main', outlineOffset: 1 },
                    }}
                    className="dismissable-card-close"
                />
            )}
            <Box
                sx={{
                    height: '100%',
                    width: '100%',
                    '&:hover .dismissable-card-close': { opacity: 1 },
                }}
            >
                {children}
            </Box>
        </Box>
    );
}
